import LabRepository from "./LabRepository";

const resource = "/analyte-range";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  batchCreate(payload) {
    return LabRepository.post(`${resource}/batch`, payload);
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  batchUpdate(payload) {
    return LabRepository.put(`${resource}/batch`, payload);
  },
  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },
  suspend(id) {
    return LabRepository.delete(`${resource}/${id}`);
  },
  deleteBatch(payload) {
    return LabRepository.delete(resource, { data: { id: payload } });
  },
  importFile(sample_type_id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return LabRepository.post(`${resource}/import/${sample_type_id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  downloadImportTemplate(sample_type_id) {
    return LabRepository.get(`${resource}/import-template/${sample_type_id}`);
  },
}
